import BasicInfoIcon from "./BasicInfoIcon";
import BasicInfoIcon2 from "./BasicInfoIcon2";
import BasicInfoIcon3 from "./BasicInfoIcon3";
import EyeIcon from "./EyeIcon";
import NameIcon from "./NameIcon";
import ProfileIconOnboarding from "./ProfileIconOnboarding";
import GalleryIcon from "./GalleryIcon";
import PickIcon from "./PickIcon";
import ReUploadIconv2 from "./ReUploadIconv2";
import FacebookIcon from "./FacebookIcon";
import InstagramIcon from "./InstagramIcon";
import InstagramIconv2 from "./InstagramIconv2";
import TweeterIcon from "./TweeterIcon";
import LinkedInIcon from "./LinkedinIcon";
import UrlIcon from "./UrlIcon";
import LocationIcon from "./LocationIcon";
import UmbrellaIcon from "./UmbrellaIcon";
import HomeIcon from "./HomeIcon";
import SuitcaseIcon from "./SuitcaseIcon";
import DisableIcon from "./DisableIcon";
import DiamondIcon from "./DiamondIcon";
import DiamondIconv2 from "./DiamondIconv2";
import LoveIcon from "./LoveIcon";
import ProfileBigIcon from "./ProfileBigIcon";
import SymbolIcon from "./@Icon";

const OnBoardingIcons = {
  BasicInfoIcon,
  BasicInfoIcon2,
  BasicInfoIcon3,
  EyeIcon,
  NameIcon,
  ProfileIconOnboarding,
  GalleryIcon,
  PickIcon,
  ReUploadIconv2,
  FacebookIcon,
  InstagramIcon,
  TweeterIcon,
  InstagramIconv2,
  LinkedInIcon,
  UrlIcon,
  LocationIcon,
  UmbrellaIcon,
  HomeIcon,
  SuitcaseIcon,
  DisableIcon,
  DiamondIcon,
  DiamondIconv2,
  LoveIcon,
  ProfileBigIcon,
  SymbolIcon,
};

export default OnBoardingIcons;
